module.exports = {"news":"最新消息","Terms of Service":"服務條款","Privacy Notice":"隱私權聲明","Frequently Asked Questions":"常見問題","Contact Us":"聯絡我們"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/subfolder/tw.json
// module id = 7INc
// module chunks = 1